import React, { useState } from "react";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";
import DiopterImages from "components/DiopterImages/DiopterImages";

const marks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 1,
    label: "-1",
  },
  {
    value: 2,
    label: "-2",
  },
  {
    value: 3,
    label: "-3",
  },
  {
    value: 4,
    label: "-4",
  },
  {
    value: 5,
    label: "-5",
  },
  {
    value: 6,
    label: "-6",
  },
];

function valuetext(value) {
  return `${value}`;
}

const PrettoSlider = styled(Slider)({
  color: "#2158CB",
  height: 8,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    pointerEvents: "all",
    height: 24,
    width: 24,
    backgroundColor: "#2158CB",
    border: "2px solid currentColor",
    "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
      boxShadow: "inherit",
    },
    "&:before": {
      display: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#2158CB",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

export default function MyopiaSimulatorTest() {
  const [diopterValue, setDiopterValue] = useState(0);

  const handleDiopterValueChange = (event, newValue) => {
    setDiopterValue(newValue);
  };

  return (
    <div className="myopia-simulator-test">
      <div className="myopia-simulator-test__slider-image">
        <DiopterImages diopterValue={diopterValue} />
      </div>
      <div className="myopia-simulator-test__slider-control">
        <div className="myopia-simulator-test__slider-control-label">
          Prescription (Diopters)
        </div>
        <div className="myopia-simulator-test__slider-control-slider">
          <PrettoSlider
            defaultValue={0}
            getAriaValueText={valuetext}
            step={1}
            marks={marks}
            max={6}
            onChange={handleDiopterValueChange}
          />
        </div>
      </div>
    </div>
  );
}
